module.exports = __webpack_public_path__ + "static/media/businesses-icon-1.7145175f.svg";